__turbopack_context__.v({
  "back": "catalog-module__NuU4yq__back",
  "heading": "catalog-module__NuU4yq__heading",
  "mono": "catalog-module__NuU4yq__mono",
  "page": "catalog-module__NuU4yq__page",
  "search": "catalog-module__NuU4yq__search",
  "sectionHeader": "catalog-module__NuU4yq__sectionHeader",
  "stat": "catalog-module__NuU4yq__stat",
  "statActive": "catalog-module__NuU4yq__statActive",
  "stats": "catalog-module__NuU4yq__stats",
  "toolbar": "catalog-module__NuU4yq__toolbar",
});
